import React, { ReactChild } from 'react';
import clsx from 'clsx';
import styles from './container.module.scss';

interface Props {
  fullScreen?: boolean;
  fullWidth?: boolean;
  children?: ReactChild | ReactChild[];
}

function Container(props: Props) {
  const { fullScreen, fullWidth, children } = props;

  const wrapperClassNames = clsx(
    styles.Container,
    fullScreen && styles.FullScreen,
    fullWidth && styles.FullWidth
  );

  return <div className={wrapperClassNames}>{children}</div>;
}

export default Container;
